export default function getMFEPath(subpath) {
  return new URL(subpath, import.meta.url).href;
}
